import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import { Link } from '@/Components/Navigation/Link'
import { UserNavigationItem } from '@/types/global'

interface UserMenuProps {
    user: { email: string }
    userNavigation: UserNavigationItem[]
}

export function UserMenuTop({ user, userNavigation }: UserMenuProps) {
    return (
        <Menu as="div" className="relative">
            <MenuButton className="-m-1.5 flex items-center p-1.5">
                <span className="sr-only">Nutzermenü öffnen</span>
                <span className="flex items-center">
                    <span aria-hidden="true" className="ml-4 text-sm leading-6 font-semibold text-stone-900">
                        {user.email}
                    </span>
                    <ChevronDownIcon aria-hidden="true" className="ml-2 h-5 w-5 text-stone-400" />
                </span>
            </MenuButton>
            <MenuItems
                transition
                className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-stone-900/5 transition focus:outline-none data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
            >
                {userNavigation.map((item) => (
                    <MenuItem key={item.name}>
                        <Link
                            href={item.href}
                            method={item.method}
                            as="button"
                            className="block w-full px-3 py-1 text-left text-sm leading-6 text-stone-900 data-focus:bg-stone-50"
                        >
                            {item.name}
                        </Link>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    )
}

export function UserMenuBottom({ user, userNavigation }: UserMenuProps) {
    return (
        <Menu as="div" className="relative">
            <MenuButton className="-m-1.5 flex items-center p-1.5">
                <span className="sr-only">Nutzermenü öffnen</span>
                <span className="flex items-center">
                    <span
                        aria-hidden="true"
                        className="max-w-[12rem] overflow-hidden text-sm leading-6 font-semibold text-ellipsis whitespace-nowrap text-stone-900"
                    >
                        {user.email}
                    </span>
                    <ChevronUpIcon aria-hidden="true" className="ml-1 h-4 w-4 text-stone-900" />
                </span>
            </MenuButton>

            <MenuItems
                anchor="bottom start"
                transition
                className="absolute z-10 mb-2.5 w-48 origin-bottom-left rounded-md bg-white py-2 shadow-lg ring-1 ring-stone-900/5 transition focus:outline-none data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
            >
                {userNavigation.map((item) => (
                    <MenuItem key={item.name}>
                        <Link
                            href={item.href}
                            method={item.method}
                            as="button"
                            className="block w-full px-3 py-1 text-left text-sm text-stone-900 data-focus:bg-stone-100"
                        >
                            {item.name}
                        </Link>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    )
}
